/*
支払方法管理画面
新規クレジットカードチェックフォーム
*/

import React, { memo } from 'react';
import classes from './new-card-check-form.module.scss';
import { displayCardBrandImage } from '../card-brand/CardBrand';

type Props = {
	onChangeEvent: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
	isCardSelected?: (i: number) => boolean;
	paymentType: string;
	label: string;
	NEW_CARD_SELECT_VALUE?: number;
};
export const NewCardCheckForm = memo((props: Props) => {
	const { onChangeEvent, isCardSelected, paymentType, label, NEW_CARD_SELECT_VALUE } = props;

	return (
		<div className={classes.paymentCreditHead}>
			<div className="radio-box">
				<ul>
					<li>
						<label
							className={`radio-label ${classes.paymentMethodLabel} ${
								isCardSelected(NEW_CARD_SELECT_VALUE) ? 'is-active' : ''
							}`}
							htmlFor={paymentType}
						>
							<input
								type="radio"
								id={paymentType}
								name={`method${NEW_CARD_SELECT_VALUE}`}
								value={NEW_CARD_SELECT_VALUE}
								checked={isCardSelected(NEW_CARD_SELECT_VALUE)}
								onChange={onChangeEvent}
							/>
							{label}
						</label>
					</li>
				</ul>
			</div>

			<div className={`${classes.paymentCreditCardBox} ${classes.flexCenter}`}>{displayCardBrandImage()}</div>
		</div>
	);
});
